import {
  Component,
  Input,
  OnInit,
  Renderer2,
  HostListener,
} from '@angular/core';

@Component({
  selector: 'app-carousel',
  standalone: true,
  imports: [],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss',
})
export class CarouselComponent implements OnInit {
  @Input() images: string[] = [];
  currentIndex: number = 0;

  get translateValue(): string {
    return `translateX(-${this.currentIndex * 100}%)`;
  }

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.currentIndex = 0; // Initialize to the first image
    // this.renderer.addClass(document.body, 'no-scroll');
  }

  closeCarousel() {
    this.currentIndex = 0;
    this.images = [];
    this.renderer.removeClass(document.body, 'no-scroll');
  }

  // Close when clicking outside the image
  closeOnBackground(event: MouseEvent): void {
    if (
      (event.target as HTMLElement).classList.contains('carousel-container')
    ) {
      this.closeCarousel();
    }
  }

  prevImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  nextImage() {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++;
    }
  }

  // Swipe left or right detection
  @HostListener('swipeleft', ['$event'])
  onSwipeLeft(event: any): void {
    this.nextImage(); // Go to the next image when swiped left
  }

  @HostListener('swiperight', ['$event'])
  onSwipeRight(event: any): void {
    this.prevImage(); // Go to the previous image when swiped right
  }
}
